import Vue from 'vue';
const MarcadorEventBus = new Vue();
export default MarcadorEventBus;
